import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as dom from '../../../base/browser/dom.js';
import { Color } from '../../../base/common/color.js';
import { Emitter } from '../../../base/common/event.js';
import { TokenizationRegistry, TokenMetadata } from '../../common/modes.js';
import { TokenTheme, generateTokensCSSForColorMap } from '../../common/modes/supports/tokenization.js';
import { hc_black, vs, vs_dark } from '../common/themes.js';
import { Registry } from '../../../platform/registry/common/platform.js';
import { Extensions } from '../../../platform/theme/common/colorRegistry.js';
import { Extensions as ThemingExtensions } from '../../../platform/theme/common/themeService.js';
import { Disposable } from '../../../base/common/lifecycle.js';
import { CodiconStyles } from '../../../base/browser/ui/codicons/codiconStyles.js';
var VS_THEME_NAME = 'vs';
var VS_DARK_THEME_NAME = 'vs-dark';
var HC_BLACK_THEME_NAME = 'hc-black';
var colorRegistry = Registry.as(Extensions.ColorContribution);
var themingRegistry = Registry.as(ThemingExtensions.ThemingContribution);

var StandaloneTheme = /*#__PURE__*/function () {
  function StandaloneTheme(name, standaloneThemeData) {
    _classCallCheck(this, StandaloneTheme);

    this.semanticHighlighting = false;
    this.themeData = standaloneThemeData;
    var base = standaloneThemeData.base;

    if (name.length > 0) {
      this.id = base + ' ' + name;
      this.themeName = name;
    } else {
      this.id = base;
      this.themeName = base;
    }

    this.colors = null;
    this.defaultColors = Object.create(null);
    this._tokenTheme = null;
  }

  _createClass(StandaloneTheme, [{
    key: "base",
    get: function get() {
      return this.themeData.base;
    }
  }, {
    key: "notifyBaseUpdated",
    value: function notifyBaseUpdated() {
      if (this.themeData.inherit) {
        this.colors = null;
        this._tokenTheme = null;
      }
    }
  }, {
    key: "getColors",
    value: function getColors() {
      if (!this.colors) {
        var colors = new Map();

        for (var id in this.themeData.colors) {
          colors.set(id, Color.fromHex(this.themeData.colors[id]));
        }

        if (this.themeData.inherit) {
          var baseData = getBuiltinRules(this.themeData.base);

          for (var _id in baseData.colors) {
            if (!colors.has(_id)) {
              colors.set(_id, Color.fromHex(baseData.colors[_id]));
            }
          }
        }

        this.colors = colors;
      }

      return this.colors;
    }
  }, {
    key: "getColor",
    value: function getColor(colorId, useDefault) {
      var color = this.getColors().get(colorId);

      if (color) {
        return color;
      }

      if (useDefault !== false) {
        return this.getDefault(colorId);
      }

      return undefined;
    }
  }, {
    key: "getDefault",
    value: function getDefault(colorId) {
      var color = this.defaultColors[colorId];

      if (color) {
        return color;
      }

      color = colorRegistry.resolveDefaultColor(colorId, this);
      this.defaultColors[colorId] = color;
      return color;
    }
  }, {
    key: "defines",
    value: function defines(colorId) {
      return Object.prototype.hasOwnProperty.call(this.getColors(), colorId);
    }
  }, {
    key: "type",
    get: function get() {
      switch (this.base) {
        case VS_THEME_NAME:
          return 'light';

        case HC_BLACK_THEME_NAME:
          return 'hc';

        default:
          return 'dark';
      }
    }
  }, {
    key: "tokenTheme",
    get: function get() {
      if (!this._tokenTheme) {
        var rules = [];
        var encodedTokensColors = [];

        if (this.themeData.inherit) {
          var baseData = getBuiltinRules(this.themeData.base);
          rules = baseData.rules;

          if (baseData.encodedTokensColors) {
            encodedTokensColors = baseData.encodedTokensColors;
          }
        }

        rules = rules.concat(this.themeData.rules);

        if (this.themeData.encodedTokensColors) {
          encodedTokensColors = this.themeData.encodedTokensColors;
        }

        this._tokenTheme = TokenTheme.createFromRawTokenTheme(rules, encodedTokensColors);
      }

      return this._tokenTheme;
    }
  }, {
    key: "getTokenStyleMetadata",
    value: function getTokenStyleMetadata(type, modifiers, modelLanguage) {
      // use theme rules match
      var style = this.tokenTheme._match([type].concat(modifiers).join('.'));

      var metadata = style.metadata;
      var foreground = TokenMetadata.getForeground(metadata);
      var fontStyle = TokenMetadata.getFontStyle(metadata);
      return {
        foreground: foreground,
        italic: Boolean(fontStyle & 1
        /* Italic */
        ),
        bold: Boolean(fontStyle & 2
        /* Bold */
        ),
        underline: Boolean(fontStyle & 4
        /* Underline */
        )
      };
    }
  }]);

  return StandaloneTheme;
}();

function isBuiltinTheme(themeName) {
  return themeName === VS_THEME_NAME || themeName === VS_DARK_THEME_NAME || themeName === HC_BLACK_THEME_NAME;
}

function getBuiltinRules(builtinTheme) {
  switch (builtinTheme) {
    case VS_THEME_NAME:
      return vs;

    case VS_DARK_THEME_NAME:
      return vs_dark;

    case HC_BLACK_THEME_NAME:
      return hc_black;
  }
}

function newBuiltInTheme(builtinTheme) {
  var themeData = getBuiltinRules(builtinTheme);
  return new StandaloneTheme(builtinTheme, themeData);
}

export var StandaloneThemeServiceImpl = /*#__PURE__*/function (_Disposable) {
  _inherits(StandaloneThemeServiceImpl, _Disposable);

  var _super = _createSuper(StandaloneThemeServiceImpl);

  function StandaloneThemeServiceImpl() {
    var _this;

    _classCallCheck(this, StandaloneThemeServiceImpl);

    _this = _super.call(this);
    _this._onColorThemeChange = _this._register(new Emitter());
    _this.onDidColorThemeChange = _this._onColorThemeChange.event;
    _this._environment = Object.create(null);
    _this._knownThemes = new Map();

    _this._knownThemes.set(VS_THEME_NAME, newBuiltInTheme(VS_THEME_NAME));

    _this._knownThemes.set(VS_DARK_THEME_NAME, newBuiltInTheme(VS_DARK_THEME_NAME));

    _this._knownThemes.set(HC_BLACK_THEME_NAME, newBuiltInTheme(HC_BLACK_THEME_NAME));

    _this._codiconCSS = CodiconStyles.getCSS();
    _this._themeCSS = '';
    _this._allCSS = "".concat(_this._codiconCSS, "\n").concat(_this._themeCSS);
    _this._globalStyleElement = null;
    _this._styleElements = [];

    _this.setTheme(VS_THEME_NAME);

    CodiconStyles.onDidChange(function () {
      _this._codiconCSS = CodiconStyles.getCSS();

      _this._updateCSS();
    });
    return _this;
  }

  _createClass(StandaloneThemeServiceImpl, [{
    key: "registerEditorContainer",
    value: function registerEditorContainer(domNode) {
      if (dom.isInShadowDOM(domNode)) {
        return this._registerShadowDomContainer(domNode);
      }

      return this._registerRegularEditorContainer();
    }
  }, {
    key: "_registerRegularEditorContainer",
    value: function _registerRegularEditorContainer() {
      if (!this._globalStyleElement) {
        this._globalStyleElement = dom.createStyleSheet();
        this._globalStyleElement.className = 'monaco-colors';
        this._globalStyleElement.innerHTML = this._allCSS;

        this._styleElements.push(this._globalStyleElement);
      }

      return Disposable.None;
    }
  }, {
    key: "_registerShadowDomContainer",
    value: function _registerShadowDomContainer(domNode) {
      var _this2 = this;

      var styleElement = dom.createStyleSheet(domNode);
      styleElement.className = 'monaco-colors';
      styleElement.innerHTML = this._allCSS;

      this._styleElements.push(styleElement);

      return {
        dispose: function dispose() {
          for (var i = 0; i < _this2._styleElements.length; i++) {
            if (_this2._styleElements[i] === styleElement) {
              _this2._styleElements.splice(i, 1);

              return;
            }
          }
        }
      };
    }
  }, {
    key: "defineTheme",
    value: function defineTheme(themeName, themeData) {
      if (!/^[a-z0-9\-]+$/i.test(themeName)) {
        throw new Error('Illegal theme name!');
      }

      if (!isBuiltinTheme(themeData.base) && !isBuiltinTheme(themeName)) {
        throw new Error('Illegal theme base!');
      } // set or replace theme


      this._knownThemes.set(themeName, new StandaloneTheme(themeName, themeData));

      if (isBuiltinTheme(themeName)) {
        this._knownThemes.forEach(function (theme) {
          if (theme.base === themeName) {
            theme.notifyBaseUpdated();
          }
        });
      }

      if (this._theme && this._theme.themeName === themeName) {
        this.setTheme(themeName); // refresh theme
      }
    }
  }, {
    key: "getColorTheme",
    value: function getColorTheme() {
      return this._theme;
    }
  }, {
    key: "setTheme",
    value: function setTheme(themeName) {
      var _this3 = this;

      var theme;

      if (this._knownThemes.has(themeName)) {
        theme = this._knownThemes.get(themeName);
      } else {
        theme = this._knownThemes.get(VS_THEME_NAME);
      }

      if (this._theme === theme) {
        // Nothing to do
        return theme.id;
      }

      this._theme = theme;
      var cssRules = [];
      var hasRule = {};
      var ruleCollector = {
        addRule: function addRule(rule) {
          if (!hasRule[rule]) {
            cssRules.push(rule);
            hasRule[rule] = true;
          }
        }
      };
      themingRegistry.getThemingParticipants().forEach(function (p) {
        return p(theme, ruleCollector, _this3._environment);
      });
      var tokenTheme = theme.tokenTheme;
      var colorMap = tokenTheme.getColorMap();
      ruleCollector.addRule(generateTokensCSSForColorMap(colorMap));
      this._themeCSS = cssRules.join('\n');

      this._updateCSS();

      TokenizationRegistry.setColorMap(colorMap);

      this._onColorThemeChange.fire(theme);

      return theme.id;
    }
  }, {
    key: "_updateCSS",
    value: function _updateCSS() {
      var _this4 = this;

      this._allCSS = "".concat(this._codiconCSS, "\n").concat(this._themeCSS);

      this._styleElements.forEach(function (styleElement) {
        return styleElement.innerHTML = _this4._allCSS;
      });
    }
  }, {
    key: "getFileIconTheme",
    value: function getFileIconTheme() {
      return {
        hasFileIcons: false,
        hasFolderIcons: false,
        hidesExplorerArrows: false
      };
    }
  }]);

  return StandaloneThemeServiceImpl;
}(Disposable);